// src/features/upload/useUploadEngine.ts

import { useContext } from 'react';
import { UploadEngineContext, type UploadEngineValue } from './UploadEngineContext';

export function useUploadEngine(): UploadEngineValue {
  const ctx = useContext(UploadEngineContext);
  if (!ctx) {
    throw new Error('useUploadEngine must be used within an UploadEngineProvider');
  }
  return ctx;
}
